import { DataGrid } from '@/components/tables/DataGrid';
import type { DataGridColumn } from '@/components/tables/DataGrid';
import { useServerDataTable } from '@/components/tables/useServerDataTable';
import { symbolRequestsApi } from '@/api/services/globalSymbols';
import type { SymbolRequestRowDto } from '@/api/types/globalSymbols';
import { formatDateTime as fmtDateTime } from '@/utils/format';

function formatDateTime(value?: string | null): string {
  return fmtDateTime(value);
}

export function RequestHistoryTab() {
  const table = useServerDataTable<SymbolRequestRowDto>({
    queryKey: ['symbolRequests', 'history'],
    fetcher: (req) => symbolRequestsApi.getHistoryForDataTable(req),
  });

  const columns: DataGridColumn<SymbolRequestRowDto>[] = [
    { key: 'symbol', header: 'Instrument', sortable: true, cell: (r) => r.symbol },
    { key: 'typeName', header: 'Instrument type', sortable: true, cell: (r) => r.typeName },
    { key: 'assetClass', header: 'Asset Class', sortable: true, cell: (r) => r.assetClass },
    { key: 'baseCurrency', header: 'Base', sortable: true, cell: (r) => r.baseCurrency },
    { key: 'quoteCurrency', header: 'Quote', sortable: true, cell: (r) => r.quoteCurrency },
    { key: 'contractSize', header: 'Contract Size', sortable: true, cell: (r) => r.contractSize },
    { key: 'digits', header: 'Digits', sortable: true, cell: (r) => r.digits },
    { key: 'countryName', header: 'Country', sortable: true, cell: (r) => r.countryName },
    { key: 'clientName', header: 'Client', sortable: true, cell: (r) => r.clientName },
    { key: 'connectorName', header: 'Connector', sortable: true, cell: (r) => r.connectorName },
    { key: 'requestType', header: 'Request type', sortable: true, cell: (r) => r.requestType },
    { key: 'status', header: 'Status', sortable: true, cell: (r) => r.status },
    { key: 'resolvedAt', header: 'Resolved at', sortable: true, cell: (r) => formatDateTime(r.resolvedAt) },
  ];

  return (
    <div className="card border-0 shadow-none">
      <div className="card-body">
        <DataGrid
          controller={table}
          columns={columns}
          rowKey={(r) => r.id}
          emptyMessage="No request history found."
        />
      </div>
    </div>
  );
}
